// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__29Fz5"};